import { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('admin_token') || null);
  const [loading, setLoading] = useState(true);

  // Token-i localStorage-dan yüklə və yoxla
  useEffect(() => {
    const initAuth = async () => {
      const savedToken = localStorage.getItem('admin_token');
      if (savedToken) {
        try {
          const response = await authApi.verifyToken();
          if (response.data.success) {
            setToken(savedToken);
            setAdmin(response.data.data.admin);
          } else {
            // Token etibarsızdırsa, sil
            localStorage.removeItem('admin_token');
            setToken(null);
          }
        } catch (error) {
          // Token yoxlanması uğursuz olduqda
          localStorage.removeItem('admin_token');
          setToken(null);
        }
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  // Login funksiyası
  const login = async (username, password) => {
    try {
      const response = await authApi.login(username, password);
      if (response.data.success) {
        const { token: newToken, admin: adminData } = response.data.data;
        setToken(newToken);
        setAdmin(adminData);
        localStorage.setItem('admin_token', newToken);
        return { success: true };
      }
      return { success: false, message: response.data.message };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Login failed'
      };
    }
  };

  // Logout funksiyası
  const logout = () => {
    setToken(null);
    setAdmin(null);
    localStorage.removeItem('admin_token');
  };

  // Parol dəyişdirmə funksiyası
  const changePassword = async (currentPassword, newPassword, confirmPassword) => {
    try {
      const response = await authApi.changePassword(currentPassword, newPassword, confirmPassword);
      if (response.data.success) {
        return { success: true, message: response.data.message };
      }
      return { success: false, message: response.data.message };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Password change failed'
      };
    }
  };

  const value = {
    admin,
    token,
    loading,
    login,
    logout,
    changePassword,
    isAuthenticated: !!token && !!admin
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

